import axios from 'axios'
const { REACT_APP_API_BASE_URL } = process.env

const validatePhone = ( phone, countryCode ) => {
    const url = `${REACT_APP_API_BASE_URL}/phone/validate`;
    const data = {
        "mobilePhoneNumber": phone,
        "mobilePhoneCountryCode": countryCode
    }
    return axios.post(url, data).then(
        response => response,
        err => err,
    );
}
export default validatePhone

